/** @format */

import { ATCEvent, HomrScheduleContent } from '@shared/data-access/interfaces';
import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { EventBusService, Events } from '@shared/data-access/services';

import { TimeService } from '@pdp/utils';
import { Timer } from './timer';

@Component({
	selector: 'common-timer',
	templateUrl: './common-timer.component.html',
	styleUrl: './common-timer.component.scss',
	standalone: false
})
export class CommonTimerComponent implements OnInit {
	/**
	 * @description
	 * homr schedule data
	 */
	@Input()
	public homrTimerContent: HomrScheduleContent;

	@Output() timerRunning = new EventEmitter<boolean>();

	/**
	 * @description
	 * is timer displayed
	 */
	public displayTimer: boolean;

	/**
	 * @description
	 * Timer object
	 */
	public timer: Timer;

	/**
	 * @description
	 * Timer text color
	 */
	public textColor = '#8d0d02';

	constructor(
		private ngZone: NgZone,
		private eventBusService: EventBusService,
		private timeService: TimeService
	) {}

	ngOnInit(): void {
		// catch the event
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		this.eventBusService.on(Events.TimerEnded, (event: ATCEvent) => {
			this.displayTimer = false;
			this.timerRunning.emit(false);
		});
		if (this.homrTimerContent) {
			this.setTimer(this.homrTimerContent);
		} else {
			this.setTimer(undefined);
		}

		if (this.timer !== undefined) {
			this.startTimer();
			this.displayTimer = true;
		}

		// Check to see if a color is provided by homR
		if (
			typeof this.homrTimerContent?.foregroundColor === 'string' &&
			this.homrTimerContent.foregroundColor.trim() !== ''
		) {
			// Use the homR color
			this.textColor = this.homrTimerContent.foregroundColor;
		}
	}

	setTimer(homrScheduleContent) {
		if (homrScheduleContent !== undefined) {
			this.timer = new Timer(
				homrScheduleContent.startDate,
				homrScheduleContent.endDate,
				this.ngZone,
				this.eventBusService,
				this.timeService
			);
		}
	}

	startTimer() {
		this.timer.startTimer();
	}
}
